// https://gist.github.com/DavidWells/54f9dd1af4a489e5f1358f33ce59e8ad
const safeAwait = promise => {
  return promise.then(data => {
    if (data instanceof Error) {
      return [data]
    }
    return [undefined, data]
  }).catch(err => [err])
}

module.exports = safeAwait
